// Older browser support fix
// https://github.com/johndatserakis/koa-vue-notes-api/issues/1
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Toasted from 'vue-toasted'
Vue.use(Toasted, {
    theme: 'bubble',
    position: 'bottom-center',
    duration: 2300,
    singleton: true
})

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: '#ADE027',
    failedColor: '#F43D41',
    thickness: '3px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import flatPickr from 'vue-flatpickr-component'
Vue.use(flatPickr)
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/dark.css'
Vue.use(flatPickr)

import SocialSharing from 'vue-social-sharing'
Vue.use(SocialSharing)

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-43582384-14',
    debug: {
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    checkDuplicatedScript: true,
    router,
    trackEvent: true
})

import truncate from '@/common/truncate'
Vue.filter('truncate', truncate)

// // Font awesome work
// import { library } from '@fortawesome/fontawesome-svg-core'
// Vue.component('font-awesome-icon', FontAwesomeIcon)
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import { faMoneyBillWave } from '@fortawesome/pro-light-svg-icons'
// import { faUsdCircle } from '@fortawesome/pro-light-svg-icons'
// import { faShareAlt } from '@fortawesome/pro-light-svg-icons'
// import { faShareAltSquare } from '@fortawesome/pro-light-svg-icons'
// import { faMegaphone as faMegaphoneSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faMegaphone } from '@fortawesome/pro-light-svg-icons'
// import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons'
// import { faFrown } from '@fortawesome/pro-light-svg-icons'
// import { faCat } from '@fortawesome/pro-light-svg-icons'
// import { faStar } from '@fortawesome/pro-light-svg-icons'
// import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faUndo } from '@fortawesome/pro-light-svg-icons'
// import { faThumbtack } from '@fortawesome/pro-light-svg-icons'
// import { faTh } from '@fortawesome/pro-light-svg-icons'
// import { faSignOutAlt } from '@fortawesome/pro-light-svg-icons'
// import { faHome } from '@fortawesome/pro-light-svg-icons'
// import { faQuestionCircle as faQuestionCircleSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faTimesCircle as faTimesCircleSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faTimes } from '@fortawesome/pro-light-svg-icons'
// import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons'
// import { faMapMarkedAlt } from '@fortawesome/pro-light-svg-icons'
// import { faCheck } from '@fortawesome/pro-light-svg-icons'
// import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'
// import { faBell } from '@fortawesome/pro-light-svg-icons'
// import { faSearch } from '@fortawesome/pro-light-svg-icons'
// import { faSearch as faSearchSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faPhone } from '@fortawesome/pro-light-svg-icons'
// import { faArrowAltUp } from '@fortawesome/pro-light-svg-icons'
// import { faArrowAltDown } from '@fortawesome/pro-light-svg-icons'
// import { faArrowAltDown as faArrowAltDownSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faArrowDown as faArrowDownSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faPencil } from '@fortawesome/pro-light-svg-icons'
// import { faImage } from '@fortawesome/pro-light-svg-icons'
// import { faImages } from '@fortawesome/pro-light-svg-icons'
// import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons'
// import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
// import { faInfoCircle as faInfoCircleSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faRocket } from '@fortawesome/pro-light-svg-icons'
// import { faCity } from '@fortawesome/pro-light-svg-icons'
// import { faGlobeAsia } from '@fortawesome/pro-light-svg-icons'
// import { faLocationCircle } from '@fortawesome/pro-light-svg-icons'
// import { faRss } from '@fortawesome/pro-light-svg-icons'
// import { faBriefcase } from '@fortawesome/pro-light-svg-icons'
// import { faStore } from '@fortawesome/pro-light-svg-icons'
// import { faCode } from '@fortawesome/pro-light-svg-icons'
// import { faPaperPlane } from '@fortawesome/pro-light-svg-icons'
// import { faEnvelope } from '@fortawesome/pro-light-svg-icons'
// import { faDesktop } from '@fortawesome/pro-light-svg-icons'
// import { faGavel } from '@fortawesome/pro-light-svg-icons'
// import { faCloud } from '@fortawesome/pro-light-svg-icons'
// import { faComment } from '@fortawesome/pro-light-svg-icons'
// import { faPaintBrush } from '@fortawesome/pro-light-svg-icons'
// import { faThumbsUp } from '@fortawesome/pro-light-svg-icons'
// import { faExternalLink } from '@fortawesome/pro-light-svg-icons'
// import { faExternalLink as faExternalLinkSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faCog } from '@fortawesome/pro-light-svg-icons'
// import { faPlayCircle } from '@fortawesome/pro-light-svg-icons'
// import { faPlayCircle as faPlayCircleRegular } from '@fortawesome/pro-regular-svg-icons'
// import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons'
// import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons'
// import { faGlobe } from '@fortawesome/pro-light-svg-icons'
// import { faGlobe as faGlobeSolid } from '@fortawesome/pro-solid-svg-icons'
// import { faCaretDown } from '@fortawesome/pro-light-svg-icons'
// import { faTwitter } from '@fortawesome/free-brands-svg-icons'
// import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
// import { faInstagram } from '@fortawesome/free-brands-svg-icons'
// import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
// import { faYoutube } from '@fortawesome/free-brands-svg-icons'
// import { faPinterest } from '@fortawesome/free-brands-svg-icons'
// import { faSnapchat } from '@fortawesome/free-brands-svg-icons'
// import { faReddit } from '@fortawesome/free-brands-svg-icons'
// library.add(
//     faMoneyBillWave,
//     faUsdCircle,
//     faShareAlt,
//     faShareAltSquare,
//     faMegaphoneSolid,
//     faMegaphone,
//     faExclamationCircle,
//     faFrown,
//     faCat,
//     faStar,
//     faStarSolid,
//     faUndo,
//     faCog,
//     faThumbtack,
//     faTh,
//     faSignOutAlt,
//     faHome,
//     faQuestionCircleSolid,
//     faTimesCircleSolid,
//     faTimes,
//     faMapMarkerAlt,
//     faMapMarkedAlt,
//     faCheck,
//     faCheckCircle,
//     faBell,
//     faSearch,
//     faSearchSolid,
//     faPhone,
//     faArrowAltUp,
//     faArrowAltDown,
//     faArrowAltDownSolid,
//     faArrowDownSolid,
//     faPencil,
//     faImage,
//     faImages,
//     faLongArrowRight,
//     faInfoCircle,
//     faInfoCircleSolid,
//     faRocket,
//     faCity,
//     faLocationCircle,
//     faRss,
//     faBriefcase,
//     faStore,
//     faCode,
//     faPaperPlane,
//     faEnvelope,
//     faDesktop,
//     faGavel,
//     faGlobeAsia,
//     faCloud,
//     faComment,
//     faPaintBrush,
//     faThumbsUp,
//     faExternalLink,
//     faExternalLinkSolid,
//     faCog,
//     faPlayCircle,
//     faPlayCircleRegular,
//     faCalendarAlt,
//     faCalendarPlus,
//     faGlobe,
//     faGlobeSolid,
//     faCaretDown,
//     faTwitter,
//     faFacebookF,
//     faInstagram,
//     faLinkedin,
//     faYoutube,
//     faPinterest,
//     faSnapchat,
//     faReddit
// )

import VueTippy from 'vue-tippy'
Vue.use(VueTippy)

import VueAnime from '@/common/animejs'
Vue.use(VueAnime)

import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
Vue.component('vue-programmatic-invisible-google-recaptcha', VueProgrammaticInvisibleGoogleRecaptcha)

import Meta from 'vue-meta'
Vue.use(Meta)

import 'vue2-animate/dist/vue2-animate.css'

import './assets/css/app.scss' // app styles

// The following two interceptor blocks are strictly for
// attaching the top-loading bar to all axios requests and
// stoping the bar on all responses.
import axios from '@/common/axios'
axios.interceptors.request.use(function (config) {
    router.app.$Progress.start()
    return config
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
    router.app.$Progress.finish()
    return response
}, function (error) {
    router.app.$Progress.fail()
    return Promise.reject(error)
})

Vue.config.productionTip = true

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
